class ClientConnectionError extends Error {
  constructor() {
    super()
    this.name = 'ClientConnectionError'
    this.message = 'Failed to get a connected client.'
  }
}

export default ClientConnectionError
